import { render, staticRenderFns } from "./MainBetslip.vue?vue&type=template&id=0e2be0b9"
import script from "./MainBetslip.vue?vue&type=script&lang=js"
export * from "./MainBetslip.vue?vue&type=script&lang=js"
import style0 from "./MainBetslip.vue?vue&type=style&index=0&id=0e2be0b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports